enum nodeActionType {
	None = 0,
	StartAProcess = 1,
	FillAForm = 2,
	ExternalWebApplication = 3,
	Archive = 4,

	Startup = 5,
	DMExplorer = 6,
	WorkflowManagement = 7,

	eBA6Integration = 8,
	HumanResources = 9,

	AllApps = 11,
	ExternalLink = 12,
	SubPanel = 13,

	/**
	 * @deprecated since 2025 R1
	 */
	ActionForm = 14,
	/**
	 * @deprecated since 2025 R1
	 */
	ActionManagement = 15,

	SupersetDashboard = 16
}

export { nodeActionType };
